import { render, staticRenderFns } from "./BaseDotsIcon.vue?vue&type=template&id=faabf7e2"
import script from "./BaseDotsIcon.vue?vue&type=script&lang=js"
export * from "./BaseDotsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports